<template>

<div>
    <DeliveredCompany  :lgSize="12" :lgOffset="0" :locParam="1" :idCity="0" :details="0" :title="company" :dFrom="date_from" :dTo="date_to"></DeliveredCompany>
    <TableCompany :dFrom="date_from" :dTo="date_to" :title="company"></TableCompany>
</div>

</template>

<script>
import DeliveredCompany from "../../components/Delivered-CompanyProfile";
import TableCompany from "../../components/Delivered-CompanyTable";


export default {
  name: "dashboard",
  props: ["company", "date_from", "date_to"],
  components: {
    DeliveredCompany,
    TableCompany
  },
};
</script>

<style>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
</style>
